import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InlineButtonComponent } from './inline-button.component';

@NgModule({
  declarations: [
    InlineButtonComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    InlineButtonComponent
  ]
})
export class InlineButtonModule { }
